var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"session"},[_vm._v("\n  同屏会话\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }